/**
 * Code Intended for getting User Info
 */
import $ from "jquery";

// Retrieve value of window.msh.siteUrl. It is being set in the html head of the page layout.
// The environment specific msh:siteurl app setting is being used.
// For cases where this js is being used on the MSH site, then window.msh.siteUrl will be empty string since
// the URL paths are relative.
const MSH_SITE_URL = (((typeof window.msh === 'undefined') || (typeof window.msh.siteUrl === 'undefined')) ? '' : window.msh.siteUrl.endsWith('/') ? window.msh.siteUrl.slice(0, -1) : window.msh.siteUrl);

var MshUser = {    
    /**
     * Returns boolean representing whether user is logged in or not
     * @returns {boolean} true if user is logged into MSH, false otherwise
     */
    isUserLoggedIn: function() {
        var isLoggedIn = false;
        $.ajax({
            url: MSH_SITE_URL + '/mshapi/user/isuserloggedin',
            type: "get",
            async: false,
            xhrFields: {
                withCredentials: true
            },
            success: function (isUserLoggedIn) {
                if (isUserLoggedIn) {
                    isLoggedIn = true;
                }
                else {
                    isLoggedIn = false;
                }
            }
        });
        return isLoggedIn;
    },

    /**
     * Initializes the MSH sign in buttons based on whether the user is signed in or not
     * @param {jQuery Element} buttonElem 
     */
    initMshSisuButtons: function(buttonElem) {
        var iconHtml = `<svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.7529 13.6029C16.9971 13.1914 17.2029 12.7543 17.3829 12.3043C17.4086 12.2271 17.4343 12.1629 17.46 12.0857C17.6271 11.6357 17.7557 11.1729 17.8457 10.6843C17.8457 10.6329 17.8586 10.5686 17.8714 10.5171C17.9486 10.0286 18 9.51429 18 9C18 3.98571 14.0143 0 9 0C3.98571 0 0 3.98571 0 9C0 9.51429 0.0514286 10.0286 0.128571 10.5171C0.128571 10.5686 0.141429 10.6329 0.154286 10.6843C0.244286 11.1729 0.372857 11.6357 0.54 12.0857C0.565714 12.1629 0.591429 12.2271 0.617143 12.3043C0.797143 12.7543 1.00286 13.1914 1.24714 13.6029C1.28571 13.6671 1.32429 13.7314 1.36286 13.7829C1.64571 14.2329 1.96714 14.6571 2.31429 15.0429C2.37857 15.1586 2.43 15.2229 2.50714 15.2486C4.14 16.9457 6.42857 17.9871 9 17.9871C12.2529 17.9871 15.0557 16.3157 16.6371 13.77C16.6757 13.7057 16.7143 13.6414 16.7529 13.59V13.6029ZM9 1.28571C13.2429 1.28571 16.7143 4.75714 16.7143 9C16.7143 9.36 16.6757 9.70714 16.6371 10.0543C16.6243 10.17 16.6114 10.2857 16.5857 10.3886C16.5471 10.6329 16.4829 10.8771 16.4186 11.1086C16.3414 11.3657 16.2514 11.6229 16.1614 11.8671C16.1357 11.9314 16.11 11.9829 16.0843 12.0471C15.8657 12.5486 15.5957 13.0243 15.2743 13.4614C14.2714 12.1371 12.9343 11.1986 11.4557 10.6971C12.3043 10.0029 12.8571 8.94857 12.8571 7.71429C12.8571 5.52857 11.1857 3.85714 9 3.85714C6.81429 3.85714 5.14286 5.52857 5.14286 7.71429C5.14286 8.94857 5.68286 10.0029 6.54429 10.6971C5.06571 11.1986 3.74143 12.1371 2.72571 13.4614C2.41714 13.0243 2.13429 12.5486 1.91571 12.0471C1.89 11.9829 1.86429 11.9314 1.83857 11.8671C1.73571 11.6229 1.65857 11.3657 1.58143 11.1086C1.51714 10.8771 1.45286 10.6329 1.41429 10.3886C1.38857 10.2729 1.37571 10.1571 1.36286 10.0543C1.31143 9.70714 1.28571 9.36 1.28571 9C1.28571 4.75714 4.75714 1.28571 9 1.28571ZM6.42857 7.71429C6.42857 6.3 7.58571 5.14286 9 5.14286C10.4143 5.14286 11.5714 6.3 11.5714 7.71429C11.5714 9.12857 10.4143 10.2857 9 10.2857C7.58571 10.2857 6.42857 9.12857 6.42857 7.71429ZM3.61286 14.5029C4.82143 12.69 6.85286 11.5714 9 11.5714C11.1471 11.5714 13.1786 12.69 14.3871 14.5029C12.9986 15.8657 11.0957 16.7143 9 16.7143C6.90429 16.7143 5.00143 15.8657 3.61286 14.5029Z" fill="#6B7373"></path>
            </svg>`
        if (this.isUserLoggedIn()) {
            $(buttonElem).html("My Shea Home " + iconHtml);
        }
        else {
            $(buttonElem).html("Sign In "+ iconHtml);
        }
    },
    /**
     * Returns user info pertaining to whether they are logged into MSH and which MSH roles they belong to
     */
    getUserInfo: function() {
        var info = null;
        $.ajax({
            url: MSH_SITE_URL + '/mshapi/user/getuserinfo',
            type: "get",
            async: false,
            xhrFields: {
                withCredentials: true
            },
            success: function (userInfo) {
                if (userInfo) {
                    console.log("got user info!!");
                }
                else {
                    console.log("missing user info!!");
                }
                info = userInfo;
            }
        });

        return info;
    }
}
export default MshUser;